import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import minMax from 'dayjs/plugin/minMax';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

// Import locales
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl-be';

type PluginEntry<T = NonNullable<unknown>> = dayjs.PluginFunc<T> | [dayjs.PluginFunc<T>, T?];

const PLUGINS = [
  customParseFormat,
  localeData,
  localizedFormat,
  isBetween,
  isSameOrAfter,
  isSameOrBefore,
  isToday,
  minMax,
  relativeTime,
  updateLocale,
  utc,
  weekOfYear,
] as const satisfies PluginEntry[];

const initPlugins = (plugins: PluginEntry[]) => {
  plugins.forEach((pluginEntry) => {
    if (!Array.isArray(pluginEntry)) {
      dayjs.extend(pluginEntry);

      return;
    }

    const [plugin, options] = pluginEntry;

    dayjs.extend(plugin, options);
  });
};

initPlugins(PLUGINS);

export default dayjs;
